module.exports = __webpack_public_path__ + "static/media/eir.9eb4c8b2.png";